import Marquee from "react-fast-marquee";

const PLATFORMS = [
  { slug: "spotify", name: "Spotify" },
  { slug: "applemusic", name: "Apple Music" },
  { slug: "tidal", name: "Tidal" },
  { slug: "youtubemusic", name: "YouTube Music" },
  { slug: "soundcloud", name: "SoundCloud" },
  { slug: "deezer", name: "Deezer" },
  { slug: "pandora", name: "Pandora" },
  { slug: "shazam", name: "Shazam" },
  { slug: "tiktok", name: "TikTok" },
  { slug: "instagram", name: "Instagram" },
];

export default function LogoMarquee() {
  return (
    <section className="py-12 border-y border-white/5 bg-[#040a1a]" data-testid="marquee-section">
      <Marquee speed={40} gradient gradientColor="#040a1a" gradientWidth={120} autoFill pauseOnHover>
        {PLATFORMS.map((p) => (
          <div key={p.slug} className="mx-10 md:mx-12 flex items-center" title={p.name}>
            <img
              src={`https://cdn.simpleicons.org/${p.slug}/94a3b8`}
              alt={p.name}
              className="h-6 md:h-7 w-auto opacity-70 hover:opacity-100 transition-opacity"
              loading="lazy"
            />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
